import { CID } from 'multiformats/cid'
import { cyrb53hash } from './../applog/applog-utils.ts'
import { AgentHash, AgentID, CidString } from '../applog/datom-types.ts'
import { Tagged } from '../types.ts'
import { UCANCapMap } from './ucan.ts'
type AgentString = Tagged<string, 'AgentString'>
type DIDString = Tagged<string, 'DID'>
export type { AgentHash, AgentString, DIDString }


export interface AppAgent {
	ag: AgentHash
	agentString: AgentString
	did: DIDString
	sign? (data: Uint8Array): Promise<Uint8Array>
	ucan?: UCANCapMap
}
export interface AppAgentForWorker extends AppAgent {
	signerSecret?: Uint8Array
}
export interface SnapRootBlock {
	applogs: CID
	applogsSignature: Uint8Array
	info: CID
	infoSignature: Uint8Array
	prev?: CID
	prevCounter?: number | null  // Sequential counter: 0 for first, then +1 for each. null = unknown (legacy/error).
}
export interface SnapBlockLogs {
	logs: CID[]
}
export interface SnapBlockChunks {
	chunks: CID[]
}
export type SnapBlockLogsOrChunks = SnapBlockLogs | SnapBlockChunks

// HACK: this is actually note3 types, not wovin
export interface IShare {
	id?: string // string hash of pub (used as unique id in IDB) `W3Name.create().toString()` starts with k51qzi5uqu5d
	createdAt: string // ISO timestamp of creation
	name: string // nick name for the pub
	isDeleted?: boolean
	purgeBeforePush?: boolean

	pk: Uint8Array // exported privatekey - needed to create WritableName for publishing //TODO: store as non-extractable / encrypted?

	autopush: boolean
	lastPush: string | null
	lastCID?: string
	latestLogTs?: string
	pubCounter?: number

	publishedBy: string // local user appAgent
	selectors?: string[] // to be used as a filter for which applogs to pub
	encryptedFor?: string | null // short agentHash
	encryptedWith?: CryptoKey | null // AES-GCM derived key from ECDH keys (local private and remote public)

	// HACK WIP #39 - shared encryption
	sharedKey?: CryptoKey | null // AES-GCM derived key from ECDH keys (local private and ipns public)
	sharedAgents?: AgentID[] | null // array of string EntityIDs for the chosen agents (we need public jwkd atoms for each of them)
	sharedKeyMap?: Map<AgentID, string> | null // uses public key from each agent to derive an aes key that is used to encrypt and btoa the sharedKey that is actually used to encrypt and decrypt the applogs
}
export interface ISubscription {
	id: string // string hash of pub (used as unique id in IDB) `W3Name.create().toString()` starts with k51qzi5uqu5d
	createdAt: string // ISO timestamp of creation
	name: string // nick name for the pub
	isDeleted: boolean

	lastPull?: string | null
	lastPullAttempt?: string | null
	autopull: boolean
	realtime?: boolean // enable real-time WebSocket updates via IPNS watcher
	lastCID?: string // ? why not CidString
	lastApplogCID?: string
	publishedBy?: string // remote publisher short agentHash
	encryptedFor?: string | undefined // short agentHash
	encryptedWith?: CryptoKey | undefined // AES-GCM derived key from ECDH keys (local private and remote public)
}
export function isShare(obj: any): obj is IShare {
	return obj?.pk !== undefined && obj?.lastPush !== undefined
}
export function isSubscription(obj: any): obj is ISubscription {
	return obj?.lastPull !== undefined
}

export type TShareSub = IShare | ISubscription

export function agentToShortHash(agentString: string) {
	return cyrb53hash(agentString, 31, 7) as string
}
